import axios from 'axios';

const getList = async function departmentServiceGetList () {
  const response = await axios.get('/api/department/');

  return response.data.data;
};

const getById = async function departmentServiceGetById (id) {
  const response = await axios.get(`/api/department/${id}`);

  return response.data.data;
};

const create = async function departmentServiceCreate (data) {
  const response = await axios.post('/api/department/', data);

  return response.data.data;
};

const update = async function departmentServiceUpdate (id, data) {
  const response = await axios.put(`/api/department/${id}`, data);

  return response.data.data;
};

const remove = async function departmentServiceRemove (id) {
  const response = await axios.delete(`/api/department/${id}`);

  return response.data.data;
};

export default {
  getList,
  getById,
  create,
  update,
  remove,
};
